<template>
    <v-row class="ma-n4" style="max-width: 640px">
        <v-col class="pa-4" cols="12" md="">
            <v-row class="ma-n4">
                <v-col class="pa-4" cols="12" md="">
                    <application-list-filter-search v-bind="{ loading }" />
                </v-col>
                <v-col class="pa-4" cols="12" md="auto" style="width: 140px">
                    <application-list-filter-sort v-bind="{ loading }" />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="pa-4" cols="12" md="auto" style="width: 140px">
            <application-list-filter-stage v-bind="{ loading }" />
        </v-col>
    </v-row>
</template>

<script>
import ApplicationListFilterSearch from "./application-list-filter-search.vue";
import ApplicationListFilterSort from "./application-list-filter-sort.vue";
import ApplicationListFilterStage from "./application-list-filter-stage.vue";

export default {
    components: {
        ApplicationListFilterSearch,
        ApplicationListFilterSort,
        ApplicationListFilterStage,
    },
    props: {
        loading: { type: Boolean, default: false },
    },
};
</script>

<style></style>
